import { register } from "register-service-worker";

if (
  process.env.NODE_ENV === "production" ||
  process.env.NODE_ENV === "staging"
) {
  register(`${process.env.BASE_URL}workbox.js`, {
    ready() {
      console.log("App is being served from cache by a service worker.");
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      // 🔑 Ensure SW takes control on first install
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; activating now…");

      // 🔑 Force activate the new SW right away
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    },
    offline() {
      console.log("No internet connection. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });

  // 🔑 Make newly activated SW immediately control all clients
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    console.log("Service worker has taken control, reloading page…");
    window.location.reload();
  });
}
